import type {AnyObject} from 'typings/portaro.fe.types';
import type {ViewableFile} from 'typings/portaro.be.types';
import {responseToData} from 'shared/utils/data-service-utils';
import {isFunction} from 'shared/utils/custom-utils';

// uses package 'ng-file-upload'
export class FileUploadService {
    public static serviceName = 'fileUploadService';

    /*@ngInject*/
    constructor(private Upload) {
    }

    public async upload(url: string, file: File, data?: AnyObject, progressCallback?: (value: number) => void): Promise<ViewableFile> {
        const request = {
            url,
            data: {...data, ...{fileData: file}},
        };

        const upload = this.Upload.upload(request);

        // Upload returns special Promise with progress, xhr, pause and other methods...
        upload.progress((event: { loaded: number, total: number }) => {
            if (isFunction(progressCallback)) {
                progressCallback(event.loaded / event.total);
            }
        });

        const response = await upload;
        return responseToData(response);
    }
}